import React, { Fragment, useEffect, useContext, useState } from "react";
import { useHistory } from "react-router-dom";
import { LayoutContext } from "../layout";
import { cartListProduct } from "../partials/FetchApi";
import { fetchData } from "./Action";
import { createOrder } from "./FetchApi";
import { FaTrashAlt } from "react-icons/fa";

const apiURL = process.env.REACT_APP_API_URL;

export const CheckoutComponent = () => {
  const history = useHistory();
  const { data, dispatch } = useContext(LayoutContext);

  const [state, setState] = useState({
    address: "",
    phone: "",
    error: false,
    success: false,
  });

  const [quantities, setQuantities] = useState({});
  const [cart, setCart] = useState([]);

  useEffect(() => {
    fetchData(cartListProduct, dispatch);
  }, [dispatch]);

  useEffect(() => {
    if (data.cartProduct && data.cartProduct.length > 0) {
      const initialQty = {};
      data.cartProduct.forEach((p) => {
        initialQty[p._id] = p.quantity || 1;
      });
      setQuantities(initialQty);
      setCart(data.cartProduct);
    }
  }, [data.cartProduct]);

  const increaseQty = (id) => {
    setQuantities((prev) => ({
      ...prev,
      [id]: (prev[id] || 1) + 1,
    }));
  };

  const decreaseQty = (id) => {
    setQuantities((prev) => ({
      ...prev,
      [id]: prev[id] > 1 ? prev[id] - 1 : 1,
    }));
  };

  const deleteProduct = (id) => {
    setCart((prev) => prev.filter((p) => p._id !== id));
    setQuantities((prev) => {
      const updated = { ...prev };
      delete updated[id];
      return updated;
    });
  };

  const handleSubTotal = (id, price) => quantities[id] * price;

  const handleTotal = () =>
    Object.entries(quantities).reduce((sum, [id, qty]) => {
      const product = cart.find((p) => p._id === id);
      return sum + (product ? product.pPrice * qty : 0);
    }, 0);

  const handlePay = async () => {
    if (!state.address || !state.phone) {
      setState({
        ...state,
        error: "Address and phone are required",
      });
      return;
    }

    const orderData = {
      allProduct: cart.map((p) => ({
        id: p._id,
        quantity: quantities[p._id] || 1,
      })),
      user: JSON.parse(localStorage.getItem("jwt")).user._id,
      amount: handleTotal(),
      address: state.address,
      phone: state.phone,
      paymentMethod: "Whatsapp",
    };

    orderData.transactionId = `WA-${Date.now()}`;
    await createOrder(orderData);

    const orderDetails = cart
      .map(
        (p) =>
          `${p.pName} x ${quantities[p._id]} = Rp ${Number(
            handleSubTotal(p._id, p.pPrice)
          ).toLocaleString("id-ID")}`
      )
      .join("%0A");

    const message = `Halo, Saya ingin order:%0A${orderDetails}%0ATotal: Rp ${Number(
      handleTotal()
    ).toLocaleString("id-ID")}%0AAlamat: ${state.address}%0ANo HP: ${
      state.phone
    }`;

    window.open(
      `https://wa.me/6281928539617?text=${message}`,
      "_blank"
    );

    localStorage.setItem("cart", JSON.stringify([]));
    dispatch({ type: "cartProduct", payload: null });
    dispatch({ type: "orderSuccess", payload: true });
    history.push("/");
  };

  const CheckoutProducts = ({ products }) => (
    <div className="space-y-4 divide-y divide-gray-200">
      {products && products.length > 0 ? (
        products.map((product) => (
          <div
            key={product._id}
            className="border rounded-lg shadow-sm p-4 flex flex-col md:flex-row md:justify-between"
          >
            <div className="flex items-center space-x-4">
              <img
                onClick={() => history.push(`/products/${product._id}`)}
                className="cursor-pointer h-20 w-20 object-cover object-center rounded"
                src={`${apiURL}/uploads/products/${product.pImages[0]}`}
                alt={product.pName}
              />

              <div className="space-y-2">
                <div className="font-semibold text-base md:text-lg truncate">
                  {product.pName}
                </div>

                <div className="text-sm text-gray-600">
                  Price:{" "}
                  <span className="text-red-600 font-semibold">
                    Rp{" "}
                    {Number(product.pPrice).toLocaleString("id-ID")}
                  </span>
                </div>
              </div>
            </div>

            <div className="flex flex-col items-end justify-between mt-4 md:mt-0">
              <button
                onClick={() => deleteProduct(product._id)}
                className="text-red-500 text-base mb-2 hover:text-red-700"
              >
                <FaTrashAlt size={13} />
              </button>

              <div className="flex items-center space-x-2">
                <button
                  onClick={() => decreaseQty(product._id)}
                  className="px-2 py-1 border rounded"
                >
                  −
                </button>

                <span>{quantities[product._id]}</span>

                <button
                  onClick={() => increaseQty(product._id)}
                  className="px-2 py-1 border rounded"
                >
                  +
                </button>
              </div>

              <div className="text-sm font-semibold text-gray-700 mt-4">
                Subtotal:{" "}
                <span className="text-red-600 font-semibold">
                  Rp{" "}
                  {Number(
                    handleSubTotal(product._id, product.pPrice)
                  ).toLocaleString("id-ID")}
                </span>
              </div>
            </div>
          </div>
        ))
      ) : (
        <div className="text-center text-gray-500">
          Product not found, add product.
        </div>
      )}
    </div>
  );

  return (
    <Fragment>
      <section className="mx-4 mt-20 md:mx-12 md:mt-32 lg:mt-24">
        <div className="text-2xl font-bold mb-4">
          Order
        </div>

        <div className="flex flex-col md:flex-row md:space-x-6">
          <div className="md:w-1/2">
            <CheckoutProducts products={cart} />

            {/* Order Summary */}
            <div className="border rounded-lg shadow-sm p-4 mt-6">
              <div className="text-lg font-semibold mb-4">
                Order Summary
              </div>

              <div className="flex justify-between text-sm mb-3">
                <span>Subtotal Produk</span>

                <span>
                  Rp{" "}
                  {Number(handleTotal()).toLocaleString("id-ID")}
                </span>
              </div>

              <div className="border-t border-gray-200 my-4"></div>

              <div className="flex justify-between items-center">
                <span className="font-semibold text-lg">
                  Total
                </span>

                <span className="text-red-600 font-bold text-xl">
                  Rp{" "}
                  {Number(handleTotal()).toLocaleString("id-ID")}
                </span>
              </div>

              <div className="text-xs text-gray-400 mt-4">
                *Harga produk belum termasuk ongkos kirim.
                Ongkos kirim akan diinformasikan melalui WhatsApp.
              </div>
            </div>
          </div>

          <div className="w-full order-first md:order-last md:w-1/2 mt-6 md:mt-0">
            <div
              onBlur={() =>
                setState({
                  ...state,
                  error: false,
                })
              }
              className="p-4 md:p-6 bg-white rounded-xl border border-gray-200 shadow-lg mb-16"
            >
              {state.error && (
                <div className="bg-red-200 py-2 px-4 rounded mb-2">
                  {state.error}
                </div>
              )}

              <div className="flex flex-col py-2">
                <label
                  htmlFor="address"
                  className="pb-2 font-medium"
                >
                  Delivery Address
                </label>

                <input
                  value={state.address}
                  onChange={(e) =>
                    setState({
                      ...state,
                      address: e.target.value,
                    })
                  }
                  type="text"
                  id="address"
                  className="border px-4 py-2 rounded"
                  placeholder="Example: Jl. Melati No.15 RT.005/RW.005, Jakarta Selatan, Kode Pos 12180."
                />
              </div>

              <div className="flex flex-col py-2 mb-2">
                <label
                  htmlFor="phone"
                  className="pb-2 font-medium"
                >
                  Phone
                </label>

                <input
                  value={state.phone}
                  onChange={(e) =>
                    setState({
                      ...state,
                      phone: e.target.value,
                    })
                  }
                  type="number"
                  id="phone"
                  className="border px-4 py-2 rounded"
                  placeholder="08xxxxxxxx"
                />
              </div>

              <div
                onClick={handlePay}
                className="w-full px-4 py-2 text-center text-white font-semibold cursor-pointer rounded"
                style={{ background: "#303031" }}
              >
                Order via WhatsApp
              </div>
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
};

export default CheckoutComponent;